import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { fetchContentStart, fetchContentSuccess, fetchContentFailure } from './readonlyContentSlice.tsx';
import { StaticContentResponse } from './types';

export const fetchStaticContent = createAsyncThunk(
  'staticContent/fetch',
  async (type: number, { dispatch }) => {
    try {
      dispatch(fetchContentStart());
      const auth = process.env.REACT_APP_BASIC_AUTH;
      const response = await axios.get<StaticContentResponse>(
        `${process.env.REACT_APP_BASE_URL}/content-management/static-content`,
        {
          params: { type },
          headers: {
            Authorization: `Basic ${auth}`,
          },
        }
      );
      dispatch(fetchContentSuccess(response.data.data));
      return response.data.data;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to fetch content';
      dispatch(fetchContentFailure(errorMessage));
      throw error;
    }
  }
);

